var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91669 35.0001C2.91669 52.7192 17.2809 67.0834 35 67.0834C52.7192 67.0834 67.0834 52.7192 67.0834 35.0001C67.0834 17.2809 52.7192 2.91675 35 2.91675C17.2809 2.91675 2.91669 17.2809 2.91669 35.0001ZM61.25 35.0001C61.25 49.4976 49.4975 61.2501 35 61.2501C20.5025 61.2501 8.75002 49.4976 8.75002 35.0001C8.75002 20.5026 20.5025 8.75008 35 8.75008C49.4975 8.75008 61.25 20.5026 61.25 35.0001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9167 39.9167C51.5735 39.9167 52.9506 41.2783 52.56 42.8884C51.8636 45.7596 50.1671 48.4213 47.6446 50.5233C44.269 53.3364 39.6906 54.9167 34.9167 54.9167C30.1428 54.9167 25.5644 53.3364 22.1888 50.5234C19.6663 48.4213 17.9698 45.7596 17.2734 42.8884C16.8828 41.2783 18.2598 39.9167 19.9167 39.9167H49.9167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyContent);
export default __webpack_public_path__ + "static/media/my-content.841677684e473339f347a1da993c482c.svg";
export { ForwardRef as ReactComponent };